import { render, staticRenderFns } from "./FileRow.vue?vue&type=template&id=5ebf1870&"
import script from "./FileRow.vue?vue&type=script&lang=js&"
export * from "./FileRow.vue?vue&type=script&lang=js&"
import style0 from "./FileRow.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports